import React from 'react';
import { useIntl } from 'react-intl';
import CohortFilterValuesNumber from './CohortFilterValuesNumber';

const CohortFilterValuesNumberRange = ({
  disabled,
  fieldType,
  onChange,
  filterUUID,
  saveErrors,
  values,
}) => {
  const intl = useIntl();
  return (
    <div className="flex">
      <CohortFilterValuesNumber
        className="aridhia-cohort-filter-values-number-min p-0 m-auto"
        filterUUID={filterUUID}
        saveErrors={saveErrors}
        values={values}
        disabled={disabled}
        onChange={onChange}
        fieldType={fieldType}
        placeholder={intl.formatMessage({ id: 'cohort.filter.minimum.placeholder' })}
      />
      <CohortFilterValuesNumber
        className="aridhia-cohort-filter-values-number-max p-0 m-auto"
        filterUUID={filterUUID}
        saveErrors={saveErrors}
        values={values}
        disabled={disabled}
        onChange={onChange}
        fieldType={fieldType}
        index={1}
        placeholder={intl.formatMessage({ id: 'cohort.filter.maximum.placeholder' })}
      />
    </div>
  );
};

export default CohortFilterValuesNumberRange;
